<div class="calculator-content {{currentSystem}}">
	<div class="noprint system-select">
		<div class="button" *ngFor="let system of allProducts" [class]="system + ' btn-system'" (click)="setAll(system)"></div>
	</div>
	<div class="form-block">
		<form class="form noprint" [formGroup]="myForm" (ngSubmit)="onFormSubmit(myForm.value)">
			<div class="proriety">
				<h2 i18n="Überschrift|Überschrift des Baurechners@@Hauptüberschrift">Eigenschaften</h2>
				<div class="input-block" *ngIf="pv.fixedValues.isolation">
					<mat-checkbox formControlName="isolation" i18n="Dämmung@@Dämmung">Dämmung</mat-checkbox>
				</div>
				<div class="input-block">
					<label for="windowQuantity" i18n="Fensteranzahl@@Fensteranzahl">Anzahl der Fenster</label><br/>
					<mat-form-field>
						<input matInput id="windowQuantity" type="number" formControlName="windowQuantity">
						<mat-error i18n="Fehler|Keine Fensteranzahl eingegeben@@FensterzahlKeineZahl" *ngIf="myForm.hasError('required') && myForm.get('windowQuantity').touched">
							Bitte eine Zahl angeben
						</mat-error>
						<mat-error i18n="Fehler|Keine gültige Fensteranzahl eingegeben@@FensterzahlUngültigeZahl" *ngIf="!myForm.get('windowQuantity').valid && myForm.get('windowQuantity').touched && !myForm.hasError('required')">
							Bitte eine Zahl zwischen 1 und 1000 eingeben
							<div *ngIf="showMiddleMullionMassage">{{middleMullionMassage}}</div>
						</mat-error>
					</mat-form-field>
				</div>
				<div class="input-block"  *ngIf="middleMullionPossible">
					<mat-checkbox i18n="Mittelpfosten@@Mittelpfosten" formControlName="middleMullion">Mittelpfosten</mat-checkbox>
				</div>
				<div class="input-block">
					<label for="width" i18n="Fensterbreite@@Fensterbreite">Breite ({{window.min}} mm - {{window.max}} mm)</label><br/>
					<mat-form-field>
						<input matInput id="width" min="{{window.min}}" max="{{window.max}}" type="number" formControlName="width">
						<mat-error i18n="Fehler|Keine gültige Fensterbreite eingegeben@@FensterbreiteUngültigeZahl" *ngIf="!myForm.get('width').valid && myForm.get('width').touched && !myForm.hasError('required')">
							Mindestbreite ist {{window.min}} mm und max. Breite ist {{window.max}} mm.
							<div *ngIf="showMiddleMullionMassage">Bitte aktivieren Sie den Mittelpfosten.</div>
						</mat-error>
						<mat-error i18n="Fehler|Keine Fensterbreite eigegeben@@FensterbreiteKeineZahl" *ngIf="myForm.hasError('required') && myForm.get('width').touched">
							Bitte eine Zahl angeben
						</mat-error>
					</mat-form-field>
					<br/>
				</div>
				<div class="input-block">
					<label for="height" i18n="Fensterhöhe@@Fensterhöhe">Höhe ({{pv.windowHeight.min}} mm - {{pv.windowHeight.max}})</label><br/>
					<mat-form-field>
						<input matInput id="height" type="number" max="{{pv.windowHeight.max}}" formControlName="height">
						<mat-error i18n="Fehler|keine gültige Fensterhöhe eingegeben@@FensterhöheUngültigeHöhe" *ngIf="!myForm.get('height').valid && myForm.get('height').touched && !myForm.hasError('required')">
							Mindesthöhe ist {{pv.windowHeight.min}} mm und Maximalhöhe ist {{pv.windowHeight.max}}
						</mat-error>
						<mat-error i18n="Fehler|Keine Zahl eingegeben@@FensterhöheKeineZahl" *ngIf="myForm.hasError('required') && myForm.get('height').touched">
							Eine Zahl angeben
						</mat-error>
					</mat-form-field>
				</div>
				<div class="input-block" *ngIf="currentSystem != 'FLL'">
					<label for="glassThickness" i18n="Glasdicke@@Glasdicke">Glasdicke</label><br/>
					<mat-form-field>
						<input matInput *ngIf="currentSystem != 'FLM'" id="glassThickness" type="number" formControlName="glassThickness">
						<mat-select *ngIf="currentSystem === 'FLM'" formControlName="glassThickness" id="glassThickness" >
							<mat-option [value]="glass.value" *ngFor="let glass of pv.fixedValues.glass">{{glass.name}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="input-block">
					<label i18n="Anzahl Lamellen@@AnzahlLamellen" for="nrLouvres">Anzahl Lamellen</label><br/>
					<mat-form-field>
						<mat-select formControlName="nrLouvres" id="nrLouvres" >
							<mat-option [value]="louvre" *ngFor="let louvre of louvres">{{middleMullion ? ' 2 x ' + louvre / 2 : louvre}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="input-block">
					<label for="louvresHeight" i18n="Lamellenhöhe@@Lamellenhöhe">Lamellenhöhe</label><br/>
					<mat-form-field>
						<input matInput id="louvresHeight" type="number" formControlName="louvresHeight">
					</mat-form-field>
				</div>
				<div  *ngIf="currentSystem != 'FLL' && currentSystem != 'FLM'">
					<div class="input-block"  >
						<label i18n="Glas Auswahl@@GlasAuswahl" for="glassTypes">Glas Auswahl</label><br/>
						<mat-form-field>
							<mat-select formControlName="glassTypes" id="glassTypes" >
								<mat-option i18n="Glas Name@@GlasName" [value]="glass.value" *ngFor="let glass of pv.fixedValues.glassTypes">{glass.name, select, 3-fach-Glas {3-fach-Glas} 2-fach-Glas {2-fach-Glas} Paneele {Paneele}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="input-block" *ngIf="glassType === 2">
						<label i18n="Ug-Wert@@Ug" for="ug">Ug-Wert</label><br/>
						<mat-form-field>
							<mat-select formControlName="ug" id="ug" >
								<mat-option [value]="ug.value" *ngFor="let ug of pv.fixedValues.ug3">{{ug.value}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="input-block" *ngIf="glassType === 1">
						<label i18n="Ug-Wert@@Ug" for="ug">Ug-Wert</label><br/>
						<mat-form-field>
							<mat-select formControlName="ug" id="ug" >
								<mat-option [value]="ug.value" *ngFor="let ug of pv.fixedValues.ug2">{{ug.value}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="input-block" *ngIf="glassType === 0">
						<label i18n="Up-Wert@@Up" for="ug">Up-Wert</label><br/>
						<mat-form-field>
							<mat-select formControlName="ug" id="ug" (selectionChange)="onChangeUp($event)">
								<mat-option [value]="up.value" *ngFor="let up of pv.fixedValues.up">{{up.name}} {{up.value}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<div class="input-block"  *ngIf="currentSystem != 'FLL' && currentSystem != 'FLM'">

					<div class="input-block" *ngIf="glassType === 2">
						<label for="psi">Ψ</label><br/>
						<mat-form-field>
							<mat-select formControlName="psi" id="psi" >
								<mat-option [value]="ug.value" *ngFor="let ug of pv.fixedValues.psi.ug3">{{ug.name}} {{ug.value}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="input-block" *ngIf="glassType === 1">
						<label for="psi">Ψ</label><br/>
						<mat-form-field>
							<mat-select formControlName="psi" id="psi" >
								<mat-option [value]="ug.value" *ngFor="let ug of pv.fixedValues.psi.ug2">{{ug.name}} {{ug.value}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>


					<div class="input-block" *ngIf="glassType === 0">
						<label for="psi" translate>Ψ</label><br/>
						<mat-form-field>
							<input matInput id="psi" type="number" formControlName="psi">
						</mat-form-field>
					</div>


				</div>

			</div>
		</form>
		<div class="calculated-values noprint">
			<h2 i18n="Überschrift|Berechnete Werte@@BerechneteWerte">Berechnete Werte</h2>
			<div class="inner-form-block">
				<div class="inner-form-block-wrapper">
					<div>
						<div class="input-block" *ngIf="currentSystem != 'FLM'">
							<label i18n="Uw-Wert@@Uw">Uw</label><br/>
							<div class="box-input">{{uw | number : '1.0-2'}} W/m²K</div>
						</div>
						<div class="input-block">
							<label for="aAero" i18n="Aaero Pro Element@@AaeroProElement">Aaero (EN 12101-2:2003) pro Element</label>
							<div id="aAero" class="box-input">{{aAero |  number : '1.0-2' }} m²</div>
						</div>
						<div class="input-block">
							<label for="aAeroTotal" i18n="Aaero gesamt@@AaeroGesamt">Aaero {myForm.get('windowQuantity').value, plural, =1 {{{myForm.get('windowQuantity').value}} Element} other {{{myForm.get('windowQuantity').value}} Elemente}}</label>
							<div id="aAeroTotal" class="box-input">{{aAeroTotal | number : '1.0-2'}} m²</div>
						</div>
						<div class="input-block">
							<label for="aGeo" i18n="Ageo pro Element@@AgeoProElement">Ageo pro Element</label>
							<div id="aGeo" class="box-input">{{aGeo | number : '1.0-2'}} m²</div>
						</div>
						<div class="input-block">
							<label for="aGeoTotal" i18n="Ageo gesamt@@AgeoGesamt">Ageo {myForm.get('windowQuantity').value, plural, =1 {{{myForm.get('windowQuantity').value}} Element gesamt} other {{{myForm.get('windowQuantity').value}} Elemente gesamt}}</label>
							<div id="aGeoTotal" class="box-input">{{aGeoTotal | number : '1.0-2'}} m²</div>
						</div>
						<div class="input-block">
							<label i18n="Windlast@@Windlast">Funktionssicherheit mit Windlast <br>(EN 12101-2:2003)</label>
							<div  class="box-input">{{windLoadSecurity}}</div>
						</div>

					</div>
				</div>
				<div *ngIf="debug" style="background: #ffcdd2; padding: 5px">
					<h2>DEBUG INFOS</h2>
					<div class="input-block" >
						<div><span>Aw</span><span class="box-input">{{louvreArea.aw| number : '1.2-4'}} m²</span></div>
						<div><span>Af</span><span class="box-input">{{louvreArea.af| number : '1.2-4'}} m²</span></div>
						<div><span>Ag</span><span class="box-input">{{louvreArea.ag| number : '1.2-4'}} m²</span></div>
						<div><span>lg</span><span class="box-input">{{louvreArea.lg| number : '1.2-4'}} m²</span></div>
						<div><span>Fläche Lammele</span><span class="box-input">{{louvreArea.louvreArea| number : '1.2-4'}} m²</span></div>
					</div>
					<div class="input-block"  >
						<div><span>Fläche oben:</span><span class="box-input">{{area.top | number : '1.2-4'}} m²</span></div>
						<div><span>Fläche unten:</span><span class="box-input">{{area.bottom | number : '1.2-4'}} m²</span></div>
						<div><span>Fläche seitlich ohne oben/unten:</span><span class="box-input">{{area.sideNoTop | number : '1.2-4'}} m² {{area.sideNoBottom | number : '1.2-4'}} m²</span></div>
						<div><span>Fläche Lam/Lam:</span><span class="box-input">{{area.louvre  | number : '1.2-4'}} m²{{area.louvreAll  | number : '1.2-4'}} m²</span></div>
						<div>Uf ohne Dämmung:</div>
						<div><span>top: </span>{{area.uf.noIsolation.top | number : '1.2-4'}}</div>
						<div><span>bottom: </span>{{area.uf.noIsolation.bottom | number : '1.2-4'}}</div>
						<div><span>side no top: </span>{{area.uf.noIsolation.side | number : '1.2-4'}}</div>
						<div><span>louvre: </span>{{area.uf.noIsolation.louvre | number : '1.2-4'}}</div>
						<div><span>Uf mit Dämmung:</span></div>
						<div><span>top: </span>{{area.uf.isolation.top | number : '1.2-4'}}</div>
						<div><span>bottom: </span>{{area.uf.isolation.bottom | number : '1.2-4'}}</div>
						<div><span>side no top: </span>{{area.uf.isolation.side | number : '1.2-4'}}</div>
						<div><span>louvre: </span>{{area.uf.isolation.louvre | number : '1.2-4'}}</div>
					</div>
					<div class="input-block" >
						<div><span>Ug*Ag:</span>{{UgAgPsiTotal.ugTimesAg}}</div>
						<div><span>ψ * lg :</span>{{UgAgPsiTotal.piTimesLg}}</div>
						<div><span>Summe UfxAf:</span>{{UgAgPsiTotal.totalUfAf}}</div>
						<div><span>Summe UfxAf mit Dämmung:</span>{{UgAgPsiTotal.totalUfAfWithIso}}</div>
					</div>
				</div>

			</div>

		</div>
	</div>


	<div class="bt-block">
		<button mat-raised-button color="primary" (click)="sendEmail()" i18n="Button|Kalkulation per Mail@@SendenPerMail" [disabled]="!myForm.valid">Kalkulation per E-Mail senden</button>
		<button mat-raised-button color="primary" (click)="addToTable()" i18n="Button|Zur Tabelle hinzufügen@ZurTAbelleHinzufügen" [disabled]="!myForm.valid">Zur Tabelle hinzufügen</button>
	</div>

	<lib-table [data]="tableData"></lib-table>
</div>
